import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";

const Index = lazy(() => import("./pages/Index"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const CancelPage = lazy(() => import("./pages/CancelPage"));
const SuccessPage = lazy(() => import("./pages/SuccessPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

const queryClient = new QueryClient();

const Root = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: "/", element: <Suspense fallback={<div>Loading...</div>}><Index /></Suspense> },
      { path: "/admin", element: <Suspense fallback={<div>Loading...</div>}><Admin /></Suspense> },
      { path: "/cancel", element: <Suspense fallback={<div>Loading...</div>}><CancelPage /></Suspense> },
      { path: "/success", element: <Suspense fallback={<div>Loading...</div>}><SuccessPage /></Suspense> },
      { path: "/privacy", element: <Suspense fallback={<div>Loading...</div>}><PrivacyPolicy /></Suspense> },
      { path: "*", element: <Suspense fallback={<div>Loading...</div>}><NotFound /></Suspense> },
    ],
  },
]);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <RouterProvider router={router} />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
